import { render, staticRenderFns } from "./StorePsi.vue?vue&type=template&id=a2f57f5c&scoped=true"
import script from "./StorePsi.vue?vue&type=script&lang=js"
export * from "./StorePsi.vue?vue&type=script&lang=js"
import style0 from "./StorePsi.vue?vue&type=style&index=0&id=a2f57f5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f57f5c",
  null
  
)

export default component.exports